import * as React from 'react'

import { useToggle } from '@factorialco/deprecated-design-system'

import type { Collection } from 'modules/core/lib/mobx-rest'

import type LeaveForm from 'modules/timeoff/lib/LeaveForm'
import medicalLeaveUpdates from 'modules/timeoff/store/collections/medicalLeaveUpdates'
import type Leave from 'modules/timeoff/store/models/Leave'
import type LeaveType from 'modules/timeoff/store/models/LeaveType'

interface Props {
  form: LeaveForm
  employeeId: string
  leaveTypes: Collection<LeaveType>
}
interface ReturnType {
  isMedical: boolean
  isConfirming: boolean
  onConfirm: () => void
  onBackConfirm: () => void
  fetchUpdates: ((leave: Leave) => Promise<unknown>) | null | undefined
}

const useMedicalLeave = ({ form, employeeId, leaveTypes }: Props): ReturnType => {
  const [isConfirming, toggleConfirm] = useToggle(false)
  const [isMedical, setIsMedical] = React.useState(false)
  const typeId = form.get('leave_type_id').value

  React.useEffect(() => {
    setIsMedical(leaveTypes.get(typeId)?.isMedicalLeave ?? false)
  }, [leaveTypes, typeId])

  const fetchUpdates = async () => {
    return medicalLeaveUpdates.fetch({
      data: {
        employee_id: employeeId,
      },
    })
  }

  return {
    isMedical,
    isConfirming,
    onConfirm: toggleConfirm(true),
    onBackConfirm: toggleConfirm(false),
    fetchUpdates: isMedical ? fetchUpdates : null,
  }
}

export default useMedicalLeave
